<template>
    <!--
				Card - Resume
    -->
    <div class="card-inner" :class="{'active':$route.name=='Resume'}" id="resume-card">
        <div class="card-wrap">
            <!--
						Resume
            -->
            <div class="content resume">
                <!-- title -->
                <div class="title">{{$t("resume.001")}}</div>

                <!-- content -->
                <div class="row">
                    <!-- experience -->
                    <div class="col col-d-6 col-t-6 col-m-12 border-line-v">
                        <div class="resume-title border-line-h">
                            <div class="icon">
                                <i class="ion ion-briefcase"></i>
                            </div>
                            <div class="name">{{$t("resume.002")}}</div>
                        </div>
                        <div class="resume-items">
                            <div v-for="(item, index) in expList" :key="index" class="resume-item border-line-h active">
                                <div class="date">{{item.date}}</div>
                                <div class="name">{{item.name}}</div>
                                <div class="company">{{item.company}}</div>
                                <ul>
                                    <template v-for="(list, index) in item.expList">
                                        <li :key="index" v-if="list!='hr'" class="fz-rem8">{{list}}</li>
                                        <hr :key="index" v-else />
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- education -->
                    <div class="col col-d-6 col-t-6 col-m-12 border-line-v">
                        <div class="resume-title border-line-h">
                            <div class="icon">
                                <i class="ion ion-university"></i>
                            </div>
                            <div class="name">{{$t("resume.003")}}</div>
                        </div>
                        <div class="resume-items">
                            <div
                                v-for="(item, index) in eduList"
                                :key="index"
                                class="resume-item border-line-h"
                                :class="{'active':item.active}"
                            >
                                <div class="date">{{item.date}}</div>
                                <div class="name">{{item.name}}</div>
                                <div class="company">{{item.company}}</div>
                                <div v-html="item.otherInfo"></div>
                            </div>
                        </div>
                    </div>

                    <div class="clear"></div>
                </div>
            </div>

            <!--
						Skills
            -->
            <div class="content skills">
                <!-- title -->
                <div class="title">{{$t("resume.004")}}</div>

                <!-- content -->
                <div class="row">
                    <!-- skill item -->
                    <div class="col col-d-6 col-t-6 col-m-12 border-line-v">
                        <div class="skills-list">
                            <div class="skill-title border-line-h">
                                <div class="icon">
                                    <i class="fas fa-desktop"></i>
                                </div>
                                <div class="name fz-rem10">{{$t("resume.005")}}</div>
                            </div>
                            <ul>
                                <li v-for="item in f2eList" :key="item.id" class="border-line-h">
                                    <div class="name fz-rem10">{{item.name}}</div>
                                    <div class="progress">
                                        <div class="percentage" :style="'width:'+item.width"></div>
                                    </div>
                                    <ul>
                                        <li v-for="(li, index) in item.list" :key="index">{{li}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- skill item -->
                    <div class="col col-d-6 col-t-6 col-m-12 border-line-v">
                        <div class="skills-list">
                            <div class="skill-title border-line-h">
                                <div class="icon">
                                    <i class="ion ion-code"></i>
                                </div>
                                <div class="name fz-rem10">{{$t("resume.006")}}</div>
                            </div>
                            <ul>
                                <li v-for="item in backEndList" :key="item.id" class="border-line-h">
                                    <div class="name fz-rem10">{{item.name}}</div>
                                    <div class="progress">
                                        <div class="percentage" :style="'width:'+item.width"></div>
                                    </div>
                                    <ul>
                                        <li v-for="(li, index) in item.list" :key="index">{{li}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        expList() {
            return [
                {
                    date: this.$t("resume.007"),
                    name: this.$t("resume.008"),
                    company: this.$t("resume.009"),
                    expList: [this.$t("resume.011"), `hr`, this.$t("resume.012"), `hr`, this.$t("resume.013")]
                },
                {
                    date: this.$t("resume.014"),
                    name: this.$t("resume.015"),
                    company: this.$t("resume.016"),
                    expList: [this.$t("resume.017"), `hr`, this.$t("resume.018"), this.$t("resume.019"), this.$t("resume.020")]
                },
                {
                    date: this.$t("resume.021"),
                    name: this.$t("resume.022"),
                    company: this.$t("resume.023"),
                    expList: [this.$t("resume.024"), `hr`, this.$t("resume.025")]
                },
                {
                    date: this.$t("resume.026"),
                    name: this.$t("resume.027"),
                    company: this.$t("resume.028"),
                    expList: [this.$t("resume.029"), `hr`, this.$t("resume.030"), `hr`, this.$t("resume.031")]
                }
            ];
        },
        eduList() {
            return [
                {
                    date: this.$t("resume.032"),
                    active: true,
                    name: this.$t("resume.033"),
                    company: this.$t("resume.034"),
                    otherInfo: `<p class="fz-rem8">${this.$t("resume.035")}</p>`
                },
                {
                    date: this.$t("resume.036"),
                    active: false,
                    name: this.$t("resume.037"),
                    company: this.$t("resume.038"),
                    otherInfo: `<a href="https://modernweb.tw" class="maincolor" target="_blank" rel="noopener noreferrer">${this.$t(
                        "resume.039"
                    )}</a>`
                },
                {
                    date: this.$t("resume.040"),
                    active: false,
                    name: this.$t("resume.041"),
                    company: this.$t("resume.042"),
                    otherInfo: `<p>${this.$t("resume.043")}</p>`
                },
                {
                    date: this.$t("resume.044"),
                    active: false,
                    name: this.$t("resume.045"),
                    company: this.$t("resume.046"),
                    otherInfo: ``
                }
            ];
        },
        f2eList() {
            return [
                {
                    name: this.$t("resume.047"),
                    width: "70%",
                    list: [
                        this.$t("resume.048"),
                        this.$t("resume.049"),
                        this.$t("resume.050"),
                        this.$t("resume.051"),
                        this.$t("resume.052")
                    ]
                },
                {
                    name: this.$t("resume.053"),
                    width: "80%",
                    list: [
                        this.$t("resume.054"),
                        this.$t("resume.055"),
                        this.$t("resume.056"),
                        this.$t("resume.057"),
                        this.$t("resume.058")
                    ]
                },
                {
                    name: this.$t("resume.059"),
                    width: "85%",
                    list: [
                        this.$t("resume.060"),
                        this.$t("resume.061"),
                        this.$t("resume.062"),
                        this.$t("resume.063"),
                        this.$t("resume.064")
                    ]
                },
                {
                    name: this.$t("resume.065"),
                    width: "50%",
                    list: [this.$t("resume.066"), this.$t("resume.067"), this.$t("resume.068")]
                }
            ];
        },
        backEndList() {
            return [
                {
                    name: this.$t("resume.069"),
                    width: "85%",
                    list: [
                        this.$t("resume.070"),
                        this.$t("resume.071"),
                        this.$t("resume.072"),
                        this.$t("resume.073"),
                        this.$t("resume.074"),
                        this.$t("resume.075")
                    ]
                },
                {
                    name: this.$t("resume.076"),
                    width: "85%",
                    list: [this.$t("resume.077"), this.$t("resume.078"), this.$t("resume.079")]
                },
                {
                    name: this.$t("resume.080"),
                    width: "80%",
                    list: [this.$t("resume.081"), this.$t("resume.082"), this.$t("resume.083")]
                },
                {
                    name: this.$t("resume.084"),
                    width: "70%",
                    list: [this.$t("resume.085"), this.$t("resume.086"), this.$t("resume.087")]
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Resume.vue